<template>
  <div class="frame">
    <div class="header">
      <slot name="header"></slot>
    </div>
    <div class="body">
      <slot name="body"></slot>
    </div>
    <div class="footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Frame",
  props: {},
  setup() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.frame {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #F2F4F9;
  .body{
    flex: 1;
    overflow-y: auto;
  }
}
</style>
